import React from "react";
import "@/App.css";
import "@/marketing.css";
import "@/editorial.css";
import "@/finish.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Systems from "@/pages/Systems";
import Technology from "@/pages/Technology";
import Branding from "@/pages/Branding";
import Training from "@/pages/Training";
import Contact from "@/pages/Contact";
import Demo from "@/pages/Demo";
import Terms from "@/pages/Terms";
import ShopPolicies from "@/pages/ShopPolicies";
import Privacy from "@/pages/Privacy";
import Ecosystem from "@/pages/Ecosystem";
import Plans from "@/pages/Plans";
import Core from "@/pages/Core";
import Estimate from "@/pages/Estimate";
import Oneill from "@/pages/Oneill";
import Products from "@/pages/Products";
import Basepoint, {OrderComplete} from "@/pages/Basepoint";
import Capability from "@/pages/Capability";
import NotFound from "@/pages/NotFound";
import ServiceLanding from "@/pages/ServiceLanding";
import servicePages from "@/lib/service-pages.json";

export function AppRoutes() {
  return (<Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
<Route path="products/oneill" element={<Oneill />} />
<Route path="products" element={<Products />} />
<Route path="products/basepoint" element={<Basepoint />} />
<Route path="shop/complete" element={<OrderComplete />} />
            <Route path="ecosystem" element={<Ecosystem />} />
            <Route path="plans" element={<Plans />} />
            <Route path="core" element={<Core />} />
            <Route path="estimate" element={<Estimate />} />
            <Route path="construction-safety-software" element={<Capability />} />
            <Route path="white-label-construction-software" element={<Capability />} />
            <Route path="construction-models-takeoffs-cut-fill" element={<Capability />} />
            <Route path="about" element={<About />} />
            <Route path="services" element={<Services />} />
            <Route path="systems" element={<Systems />} />
            <Route path="technology" element={<Technology />} />
            <Route path="branding" element={<Branding />} />
            <Route path="training" element={<Training />} />
            <Route path="demo" element={<Demo />} />
            <Route path="contact" element={<Contact />} />
            <Route path="terms" element={<Terms />} />
<Route path="shop/policies" element={<ShopPolicies />} />
            <Route path="privacy" element={<Privacy />} />
            {Object.keys(servicePages).map(path=><Route key={path} path={path.slice(1)} element={<ServiceLanding/>}/>)}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>);
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid #27272a",
            borderRadius: 0,
            color: "#fafafa",
            fontFamily: "'IBM Plex Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;


